import { combineReducers } from 'redux';
import { httpData } from "./httpData.redux";
import { config } from "./config.redux";
import { formDataValue } from "./superFrom.redux";



export default combineReducers({ httpData, config, formDataValue });



// WEBPACK FOOTER //
// ./src/reducer/index.js